<app-navbar></app-navbar>

<router-outlet></router-outlet>

<app-footer></app-footer>

<button *ngIf="showButton" (click)="onScrollTop()" class="button" style="color: white;"> <i class="fas fa-arrow-up"></i> </button>
